export default "__VITE_PUBLIC_ASSET__3e91eb50__"